import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const input = 'w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm focus:border-purple-500 outline-none';

export const AdminClientTools = ({ client, token, onClose, onDone }) => {
  const [mint, setMint] = useState('');
  const [line, setLine] = useState('');
  const [busy, setBusy] = useState('');
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const sub = client.subscription;
  const officer = sub && ['active', 'trialing'].includes(sub.status);

  const call = async (key, path, body) => {
    setBusy(key);
    try {
      const res = await axios.post(`${API}/pas-banking/admin/clients/${client.client_id}/${path}`, body, auth);
      toast.success(res.data.message || 'Saved');
      onDone();
    } catch (err) { toast.error(err.response?.data?.detail || 'Action failed'); }
    finally { setBusy(''); }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-testid="admin-client-tools-modal">
      <div className="bg-slate-800 rounded-2xl p-6 max-w-md w-full relative space-y-5">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white" data-testid="admin-client-tools-close"><X className="w-5 h-5" /></button>
        <div>
          <h3 className="text-xl font-bold text-white">{client.first_name} {client.last_name}</h3>
          <p className="text-slate-400 text-sm">{client.email}</p>
          <p className="text-emerald-400 text-xs font-mono break-all mt-1">{client.wallet_address}</p>
        </div>
        <div className="border-t border-slate-700 pt-4">
          <p className="text-sm text-slate-300 mb-2">Treasury Officer subscription: <span className="text-white" data-testid="admin-client-sub-status">{officer ? (sub.waived ? 'Active (fee waived)' : 'Active (paid)') : 'Not active'}</span></p>
          <button onClick={() => call('waive', 'waive-subscription', { waive: !(officer && sub.waived) })} disabled={busy === 'waive'}
            data-testid="admin-waive-subscription-btn" className="px-4 py-2 bg-amber-500/20 text-amber-300 hover:bg-amber-500/30 rounded-lg text-sm">
            {officer && sub.waived ? 'Revoke waiver' : 'Waive $499/month fee'}
          </button>
        </div>
        <div className="border-t border-slate-700 pt-4">
          <p className="text-sm text-slate-300 mb-2">Daily transaction limit: <span className="text-white" data-testid="admin-client-limit-status">{client.daily_limit_exempt ? 'No limit' : '$250,000 / day'}</span></p>
          <button onClick={() => call('limit', 'daily-limit', { exempt: !client.daily_limit_exempt })} disabled={busy === 'limit'}
            data-testid="admin-daily-limit-toggle-btn" className="px-4 py-2 bg-purple-500/20 text-purple-300 hover:bg-purple-500/30 rounded-lg text-sm">
            {client.daily_limit_exempt ? 'Restore $250k daily limit' : 'Remove daily limit'}
          </button>
        </div>
        <div className="border-t border-slate-700 pt-4">
          <p className="text-sm text-slate-300 mb-2">Mint BETH on-chain to this wallet (Sepolia/Mainnet)</p>
          <div className="flex gap-2">
            <input type="number" min="1" value={mint} onChange={(e) => setMint(e.target.value)} placeholder="BETH amount" className={input} data-testid="admin-mint-amount-input" />
            <button onClick={() => call('mint', 'mint', { beth_amount: parseFloat(mint) })} disabled={!mint || busy === 'mint'} data-testid="admin-mint-btn" className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-sm disabled:opacity-50">{busy === 'mint' ? 'Minting...' : 'Mint'}</button>
          </div>
        </div>
        <div className="border-t border-slate-700 pt-4">
          <p className="text-sm text-slate-300 mb-2">Grant an approved credit line (USD)</p>
          <div className="flex gap-2">
            <input type="number" min="1" value={line} onChange={(e) => setLine(e.target.value)} placeholder="USD amount" className={input} data-testid="admin-grant-line-input" />
            <button onClick={() => call('line', 'credit-line', { amount_usd: parseFloat(line) })} disabled={!line || busy === 'line'} data-testid="admin-grant-line-btn" className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg text-sm disabled:opacity-50">Grant</button>
          </div>
        </div>
      </div>
    </div>
  );
};
